import { getValueFromMeta } from '@/utils/utils';

export const spaceName = 'odOrderProcessing';

export interface OrderProcessingSettings {
  data?: any;
  selectedIds: any[];
  viewingOrder?: any;
  showDrawer: boolean;
  showModal: {
    show: boolean;
    key?: string;
  };
}

export default {
  selectedIds: [],
  showDrawer: false,
  showModal: {
    show: false,
  },
} as OrderProcessingSettings;

export const getTableColumns = (props: any) => {
  const {
    helper: { tx },
    od: { editingBusiness },
    subtotalButton,
    actionButton,
    status,
    shippingMethod,
  } = props;

  const enableTradingMode = getValueFromMeta(editingBusiness.meta, 'enable_trading_mode');

  return [
    {
      title: enableTradingMode
        ? tx('Orders_Payments.order_number')
        : tx('Orders_Payments.table_or_ref_number'),
      dataIndex: 'referenceNumber',
      key: 'tableNumber',
      width: '130px',
    },
    { ...status },
    { ...shippingMethod },
    {
      title: tx('Orders_Payments.order_time'),
      dataIndex: 'orderTime',
      key: 'orderTime',
      width: '200px',
    },
    {
      ...subtotalButton,
    },
    {
      ...actionButton,
    },
  ];
};

export const getChildrenTableColumns = () => {
  return [];
};
